import { Box, Button, CircularProgress, Grid, TextField } from '@mui/material'
import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { Link } from 'react-router-dom'
import { toast } from '../features/snackbar/snackbarSlice'
import Logo from '../Logo'
import { useForgotPasswordMutation } from '../services/api'
import { useRedirectUrl } from '../useRedirectUrl'

const ForgotPassword = () => {
  const redirectUrl = useRedirectUrl()
  const [usernameOrEmail, setUsernameOrEmail] = useState<string>('')
  const dispatch = useDispatch()
  const [
    forgotPassword,
    { isLoading },
  ] = useForgotPasswordMutation()

  const disabled = !usernameOrEmail || isLoading
  return (
    <Grid
      container
      spacing={0}
      direction="column"
      alignItems="center"
      justifyContent="center"
      style={{
        minHeight: '100vh'
      }}
    >
      <Logo height={128} />
      <br />
      <Grid
        item
        xs={3}
      >
        Please enter your username or email address.
      </Grid>
      <br />
      <br />
      <Grid
        item
        xs={3}
      >
        <Box
          autoComplete="off"
          component="form"
          display='inline-grid'
          onSubmit={(e: any) => {
            e.preventDefault()
            forgotPassword({
              usernameOrEmail,
            })
              .unwrap()
              .then(() => {
                dispatch(
                  toast({
                    message: 'Email successfully sent',
                    severity: 'success'
                  })
                )
              })
              .catch(err => {
                console.error(err)
                dispatch(
                  toast({
                    message: 'Unsuccessful',
                    severity: 'error',
                  })
                )
              })
          }}
          sx={{
            '& .MuiTextField-root': {
              mt: 1,
              minWidth: '25ch'
            },
          }}
          textAlign='center'
        >
          <TextField
            autoComplete="current-username"
            autoFocus
            fullWidth
            label="Username or Email"
            onChange={e => setUsernameOrEmail(e.target.value)}
            required
            value={usernameOrEmail}
          />
          <br />
          <Button
            disabled={disabled}
            type='submit'
            variant="contained"
          >{isLoading
            ? <CircularProgress
              size={25}
            />
            : 'Send Email'
            }</Button>
          <br />
          <Link
            to={`/login${!redirectUrl ? '' : `?redirectUrl=${encodeURIComponent(redirectUrl)}`}`}
          >Back to Login</Link>
        </Box>
      </Grid>
    </Grid>
  )
}

export default ForgotPassword